module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "m-l-50 m-t-30"
  }, [_c('common-config', {
    attrs: {
      "id": _vm.id,
      "form": _vm.form,
      "inputList": _vm.inputList
    }
  }, [_c('template', {
    slot: "self-config"
  }, [_c('el-form-item', {
    attrs: {
      "label": "关联字段",
      "prop": "title"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.download_field),
      expression: "form.download_field"
    }],
    staticClass: "fl w-200 m-r-10",
    attrs: {
      "multiple": "",
      "placeholder": "关联字段"
    },
    domProps: {
      "value": (_vm.form.download_field)
    },
    on: {
      "input": function($event) {
        _vm.form.download_field = $event
      }
    }
  }, _vm._l((_vm.inputList), function(option) {
    return (option.default.type == _vm.TYPE_FILE) ? _c('el-option', {
      attrs: {
        "label": option.default.name + '(' + option.default.title + ')',
        "value": option.default.field_id
      }
    }) : _vm._e()
  }))])])], true)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bbb01892!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/abstract/dealConfig/downloadConfig.vue
// module id = 1980
// module chunks = 2